import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
const UserData1 = ({ user, surveydayarr }) => {
  const { t } = useTranslation();
  return (
    <ul>
      <li className="flex mt-4 gap-x-2">
        <div className="w-1/2 flex items-center bg-[#FAFCFF] p-3 rounded-xl ">
          <span className="block w-1/3 caption_1_600">{t('UserData1_name', '이름')}</span>
          <span className="block body_1_600">{user.name}</span>
        </div>
        <div className="w-1/2 flex items-center bg-[#FAFCFF] p-3 rounded-xl gap-2">
          <span className="block w-1/3 caption_1_600">{t('UserData1_registrationNumber', '등록번호')}</span>
          <span className="block body_1_600">
            {user.patientID?.slice(0, 2) + "****"}
          </span>
        </div>
      </li>

      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_birthDate', '생년월일')}</span>
        <span className="block body_1_600">{user.birth}</span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_gender', '성별')}</span>
        <span className="block body_1_600">
          {user.gender === "M" ? t('UserData1_male', '남성') : user.gender === "F" ? t('UserData1_female', '여성') : ""}
        </span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_appJoinDate', '앱 가입일')}</span>
        <span className="block body_1_600">
          {user.agreeDate ? dayjs(user.agreeDate).format("YYYY-MM-DD") : ""}
        </span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_participationStartDate', '참여 시작일')}</span>
        <span className="block body_1_600">
          {user.startDate ? dayjs(user.startDate).format("YYYY-MM-DD") : ""}
        </span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_participationEndDate', '참여 종료일')}</span>
        <span className="block body_1_600">
          {user.endDate ? user.endDate : ""}
        </span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_stomaCheckDate', '장루 점검일')}</span>
        <span className="block body_1_600">
          {surveydayarr !== null
            ? t('UserData1_monthlyDays', '매월 {{day1}}일, {{day2}}일', { day1: surveydayarr[0], day2: surveydayarr[1] })
            : ""}
        </span>
      </li>
      <li className="mt-4 bg-[#FAFCFF] p-3 rounded-xl flex items-center">
        <span className="block w-1/3 caption_1_600">{t('UserData1_phoneNumber', '휴대폰번호')}</span>
        <span className="block body_1_600">{user.phone ? user.phone : ""}</span>
      </li>
    </ul>
  );
};

export default UserData1;
